import { useEffect, useReducer } from "react";
import { IntlProvider } from "react-intl";
import ENGLISH from "../../../i18n/languages/en-US.json";
import { useParams } from "react-router-dom";
import { pig } from "../../../static/js/pig.js";
import Header from "./Header";
import Loader from "../../common/elements/Loader";
import { sendRequest } from "@/common/http";
import ParticipationOverview from "../ParticipationOverview";
import { ParticipationOverviewInterface } from "../Sll";
import { StudentAssessmentProgressByTerm } from "./AssessmentProgressChart";
import "../Sll.scss";
import "../../../app/App.scss";
import AssessmentProgressChart from "./AssessmentProgressChart";
import { defaultReportingYear } from "../../common/interfaces/Interface";
import ApiError from "../../common/elements/ApiError";
import UnauthorizedComponent from "@/features/insights/UnauthorizedComponent";
export interface LearningAssessments {
  noActivityTerms: string;
  participationOverview: ParticipationOverviewInterface | null;
  studentAssessmentProgressByTerm: StudentAssessmentProgressByTerm[] | [];
}

interface ReportingYear {
  endDate: string;
  name: string;
  startDate: string;
  uuid: string;
}

interface UrlParams {
  reporting_year_uuid: string;
}

interface SllState {
  reportingYear: ReportingYear | null;
  reportingYearAuth: Boolean;
  messages: any;
  locale: string;
  learningAssessments: LearningAssessments;
  assessmentError: boolean;
  reportingYearError: boolean;
}
interface SllAction {
  type: string;
  reportingYear: ReportingYear | null;
  locale: string | null;
  assessmentError: boolean;
  reportingYearError: boolean;
  learningAssessments: LearningAssessments;
}
const sllAction = {
  type: "",
  reportingYear: defaultReportingYear,
  locale: "en-US",
  assessmentError: false,
  reportingYearError: false,
  learningAssessments: {
    noActivityTerms: "",
    participationOverview: null,
    studentAssessmentProgressByTerm: []
  }
};

const reducer = (state: SllState, action: SllAction) => {
  switch (action.type) {
    case "setReportingYear":
      if (action.reportingYear) {
        return { ...state, reportingYear: action.reportingYear };
      } else {
        return { ...state, reportingYear: null, reportingYearAuth: false };
      }
    case "setLocale":
      return setLocale(state, action.locale);
    case "setLearningAssessments":
      return {
        ...state,
        learningAssessments: action.learningAssessments,
        assessmentError: false
      };
    case "setAssessmentError":
      return { ...state, assessmentError: action.assessmentError };
    case "setReportingYearError":
      return { ...state, reportingYearError: action.reportingYearError };
    default:
      return state;
  }
};

const setLocale = (state: SllState, locale: string | null) => {
  switch (locale) {
    case "pig": {
      return { ...state, locale: "en-US", messages: pig(ENGLISH) };
    }
    default: {
      return { ...state, locale: "en-US", messages: ENGLISH };
    }
  }
};

export interface SllExportViewProps {
  auth: boolean | undefined;
}

export default function SllExportView({
  auth
}: SllExportViewProps): JSX.Element {
  const initialState = {
    reportingYearAuth: true,
    locale: "en-US",
    messages: null,
    reportingYear: null,
    assessmentError: false,
    reportingYearError: false,
    learningAssessments: {
      noActivityTerms: "",
      participationOverview: null,
      studentAssessmentProgressByTerm: []
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const { reporting_year_uuid: reportingYearUuid } = useParams<UrlParams>();

  useEffect(() => {
    const queryString = window.location.search;
    const param = new URLSearchParams(queryString);
    const locale = param.get("locale");
    dispatch({ ...sllAction, type: "setLocale", locale: locale });
  }, []);

  useEffect(() => {
    const applyResult = (result: ReportingYear) => {
      dispatch({
        ...sllAction,
        type: "setReportingYear",
        reportingYear: result,
        reportingYearError: false
      });
    };
    const onError = () => {
      dispatch({
        ...sllAction,
        type: "setReportingYearError",
        reportingYearError: true
      });
    };
    auth &&
      sendRequest(
        {
          uri: `/sa/reporting_years/${reportingYearUuid}`,
          camelize: true
        },
        applyResult,
        onError
      );
  }, [auth]);
  useEffect(() => {
    if (state.reportingYear) {
      const applyResult = (result: LearningAssessments) => {
        dispatch({
          ...sllAction,
          type: "setLearningAssessments",
          learningAssessments: result
        });
      };
      const onError = () => {
        dispatch({
          ...sllAction,
          type: "setAssessmentError",
          assessmentError: true
        });
      };
      auth &&
        sendRequest(
          {
            uri: `/sll/learning_assessments?start_date=${
              state.reportingYear.startDate
            }&end_date=${state.reportingYear.endDate}&with_activities=${true}`,
            camelize: true
          },
          applyResult,
          onError
        );
    }
  }, [auth, state.reportingYear]);

  return (
    <>
      {auth && state.reportingYearAuth ? (
        <div className="pagewrapper sll-html-container">
          <div className="insights-hub-body flex-row">
            <div className="nav-main">
              <div className="contentwrapper">
                {!state.reportingYearError && (
                  <main id="maincontent" className="main-container">
                    {state.messages && (
                      <IntlProvider
                        locale={state.locale}
                        messages={state.messages}
                      >
                        {!state.assessmentError &&
                        (!state.reportingYear ||
                          !state.learningAssessments?.participationOverview) ? (
                          <Loader />
                        ) : (
                          ""
                        )}
                        <div id="sll-html" className="sll-html-container">
                          {state.reportingYear && (
                            <Header
                              reportingYear={state.reportingYear.name}
                              showDownloadBtn={!state.assessmentError}
                            />
                          )}

                          {!state.assessmentError && (
                            <section
                              className="-mainheader -withbreadcrumbs only-breadcrumbs body-padding"
                              id="page-header"
                            >
                              <div
                                id="participation-overview"
                                className="sll-section sll-section-html"
                              >
                                {state.reportingYear && (
                                  <ParticipationOverview
                                    overview={
                                      state.learningAssessments
                                        .participationOverview
                                    }
                                    reportingYear={state.reportingYear.name}
                                  />
                                )}
                                {state.reportingYear && (
                                  <AssessmentProgressChart
                                    assessmentProgress={
                                      state.learningAssessments
                                        .studentAssessmentProgressByTerm
                                    }
                                    noActivityTerms={
                                      state.learningAssessments.noActivityTerms
                                    }
                                  ></AssessmentProgressChart>
                                )}
                              </div>
                            </section>
                          )}
                        </div>
                      </IntlProvider>
                    )}
                    {state.assessmentError && <ApiError />}
                  </main>
                )}
                {state.reportingYearError && <ApiError />}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <UnauthorizedComponent />
      )}
    </>
  );
}
